// ToolsActionRegistry.js
export const MastersActionRegistry = {
  SECTION_KEY: "Masters",
  EDIT_SID: "SID Creation Edit",
  PAYOUT_MASTER_EDIT: "Payout Master",
  BBPS_EDIT: "BBPS Master",
  ENABLE_SID_EDIT: "SID Master",
  SID_DETAILS_EDIT: "SID Master",
  SID_MERCHANT_ONBOARDING_EDIT: "Sid Merchant  Onboarding",
};

// ToolsActionRegistry.js
export const ToolsActionRegistry = {
  SECTION_KEY: "Tools",
  HOLD_KEY: "Tools Hold & Deposit",
  TOOLS_WITHDRAW: "Tools Withdraw",
  TOOLS_OTHERS: "Tools Others",
  TOOLS_USER_KEY: "Tools User Management",
  PAYIN_ROUTING_EDIT: "Payin Routing Edit",
  PAYOUT_ROUTING_EDIT: "Payout Routing Edit",
  EKYC_ROUTING_EDIT: "E kyc Routing Edit",
  MERHCANT_DETAIL_EDIT: "Merchant Details Edit",
  HOLD_EDIT: "Hold Edit",
  GUARANTEE_AMOUNT_EDIT: "Guarantee Amount Edit",
  DEPOSIT_EDIT: "Deposit Edit",
  RELEASE_AMOUNT_EDIT: "Release Amount Edit",
  FLAG_EDIT: "Flag Edit",
  EDIT_SID: "SID Creation Edit",
  FRM_ROUTING_EDIT: "FRM ROUTING_RULES EDIT",
  PAYOUT_FRM_ROUTING_EDIT: "PAYOUT FRM ROUTING_RULES EDIT",
  BILLING_EDIT: "Billing Edit",
  USER_CREATE: "User Create",
  USER_EDIT: "User Edit",
  USER_VIEW: "User View",
  DROP_CREDIT_EDIT: "Drop Credit Edit",
  MDR_EDIT: "MDR Edit",
  MANUAL_REQUEST_EDIT: "Manual Request Edit",
  WITHDRAW_REQUEST_APPROVE_REJECT: "Withdraw Request Approve / Reject",
  WHITELIST_RULE_EDIT: "Whitelist Rule",
};

export const OnBoardingActionRegistry = {
  SECTION_KEY: "Onboarding",
  PHSE_1_EDIT: "Application phase 1 Approve reject",
  PHSE_2_EDIT: "Application phase 2 Approve reject",
  PAYIN_EDIT: "Payin Routing Edit",
  PAYOUT_EDIT: "Payout Routing Edit",
  EKYC_EDIT: "E kyc Routing Edit",
  MDR_EDIT: "MDR Edit",
  FRM_EDIT: "FRM View",
};

export const MasterMerchantActionRegistry = {
  SECTION_KEY: "Master Merchant Management",
  MASTER_CREATE: "Master Merchant Create",
  MATSER_EDIT: "Master Merchant Edit",
  MASTER_VIEW: "Master Merchant View",
};
